var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1937 43C63.6155 43 64.9627 52.3577 64.9627 52.3577L64.9867 62.0524H85.5785V64.9631H56.808C56.808 64.9631 43 63.3971 43 85.1694C43 106.942 55.052 106.17 55.052 106.17H62.2445V96.0668C62.2445 96.0668 61.8567 84.0148 74.104 84.0148H94.5274C94.5274 84.0148 106.002 84.2002 106.002 72.9251V54.2824C106.002 54.2824 107.745 43 85.1937 43ZM73.8394 49.5196C74.3261 49.5191 74.8079 49.6146 75.2576 49.8006C75.7072 49.9867 76.1158 50.2595 76.4599 50.6036C76.8039 50.9477 77.0768 51.3562 77.2628 51.8058C77.4488 52.2555 77.5443 52.7374 77.5439 53.224C77.5443 53.7106 77.4488 54.1925 77.2628 54.6421C77.0768 55.0918 76.8039 55.5004 76.4599 55.8444C76.1158 56.1885 75.7072 56.4614 75.2576 56.6474C74.8079 56.8333 74.3261 56.9289 73.8394 56.9284C73.3528 56.9289 72.871 56.8333 72.4213 56.6474C71.9717 56.4614 71.5631 56.1885 71.2191 55.8444C70.875 55.5004 70.6021 55.0918 70.4161 54.6421C70.2301 54.1925 70.1346 53.7106 70.135 53.224C70.1346 52.7374 70.2301 52.2555 70.4161 51.8058C70.6021 51.3562 70.875 50.9477 71.2191 50.6036C71.5631 50.2595 71.9717 49.9867 72.4213 49.8006C72.871 49.6146 73.3528 49.5191 73.8394 49.5196Z",
    fill: "url(#paint0_linear_347_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8065 127.557C107.385 127.557 106.038 118.199 106.038 118.199L106.014 108.505H85.4214V105.594H114.192C114.192 105.594 128 107.16 128 85.3868C128 63.6141 115.948 64.3862 115.948 64.3862H108.755V74.4895C108.755 74.4895 109.143 86.5414 96.8959 86.5414H76.4725C76.4725 86.5414 64.998 86.356 64.998 97.6315V116.275C64.998 116.275 63.2559 127.557 85.8065 127.557ZM97.1608 121.038C96.6742 121.038 96.1923 120.943 95.7427 120.757C95.293 120.571 94.8845 120.298 94.5404 119.954C94.1964 119.61 93.9235 119.201 93.7374 118.751C93.5515 118.302 93.4559 117.82 93.4564 117.333C93.4559 116.847 93.5514 116.365 93.7374 115.915C93.9233 115.465 94.1962 115.057 94.5403 114.713C94.8844 114.369 95.2929 114.096 95.7426 113.91C96.1922 113.724 96.6742 113.628 97.1608 113.628C97.6474 113.628 98.1293 113.724 98.579 113.91C99.0286 114.096 99.4372 114.368 99.7812 114.712C100.125 115.057 100.398 115.465 100.584 115.915C100.77 116.364 100.866 116.846 100.865 117.333C100.866 117.819 100.77 118.301 100.584 118.751C100.398 119.201 100.125 119.609 99.7812 119.953C99.4372 120.297 99.0286 120.57 98.579 120.756C98.1293 120.942 97.6474 121.038 97.1608 121.038Z",
    fill: "url(#paint1_linear_347_156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_156",
    x1: 51.1685,
    y1: 50.6055,
    x2: 93.2919,
    y2: 92.3087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_156",
    x1: 77.0238,
    y1: 77.3834,
    x2: 122.26,
    y2: 120.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white",
    transform: "translate(43 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonImg);
export default __webpack_public_path__ + "static/media/pythonImg.9ae3982e52b6833ff314a37dd8896e96.svg";
export { ForwardRef as ReactComponent };